import { render, staticRenderFns } from "./ClassSessionDetail.vue?vue&type=template&id=ef7595e2"
import script from "../../services/class-session/class-session-detail.js?vue&type=script&lang=js&external"
export * from "../../services/class-session/class-session-detail.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports